import {Component, Inject, Input, OnInit} from '@angular/core';
import {IQaModel} from '../../../core/models/qa.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {JobApplicationsModel} from '../../../core/models';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {validateAllFormFields} from '../../utils/form.utils';

@Component({
  selector: 'app-question-editor-dialog',
  templateUrl: './question-editor-dialog.component.html',
  styleUrls: ['./question-editor-dialog.component.css']
})
export class QuestionEditorDialogComponent implements OnInit {
  qaForm: FormGroup;
  answersControls = new FormArray([]);
  options = [
    {value: 'open', label: 'שאלה פתוחה'},
    {value: 'regular', label: 'שאלה אמריקאית'}
  ];
  mode: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { mode: string, qa: IQaModel },
    private mdDialogRef: MatDialogRef<QuestionEditorDialogComponent>,
    private fb: FormBuilder,
  ) {
    this.qaForm = this.fb.group({
      _id: '',
      type: ['', Validators.required],
      question: ['', Validators.required],
      answer: this.answersControls
    });
  }

  ngOnInit() {
    this.mode = this.data.mode;
    if (this.mode === 'edit') {
      this.qaForm.patchValue(this.data.qa);
      if (this.data.qa.type === 'regular') {
        const options = this.data.qa.answer;
        for (const i of options) {
          this.addAnswer(i);
        }
      }
    }
  }

  close() {
    this.mdDialogRef.close();
  }

  submit() {
    if (this.qaForm.invalid) {
      validateAllFormFields(this.qaForm);
      return;
    }
    this.mdDialogRef.close(this.qaForm.value as IQaModel);
  }

  addAnswer(answer: string) {
    if (answer) {
      this.answersControls.push(new FormControl(answer));
    }
  }

  deleteAnswer(index: number) {
    this.answersControls.removeAt(index);
  }

  typeChange() {
    console.log(this.qaForm.get('type').value);
    if (this.qaForm.get('type').value === 'regular') {
      this.qaForm.get('answer').setValidators([Validators.required]);
      this.qaForm.get('answer').updateValueAndValidity();
    } else {
      this.qaForm.get('answer').clearValidators();
      this.qaForm.get('answer').updateValueAndValidity();
    }
  }
}
